import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../images/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const linkClass = (path) => `
    text-sm md:text-base 
    font-medium 
    hover:text-[#8b123b] 
    transition-colors
    ${location.pathname === path ? 'text-[#8b123b]' : 'text-[#003B5C]'}
  `;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 shadow-sm" style={{ backgroundColor: 'rgba(124, 231, 202, 0.9)' }}>
      <div className="max-w-7xl mx-auto px-4 py-2 sm:py-3 md:py-4 lg:py-3">
        <nav className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="relative z-50">
            <img 
              src={logo} 
              alt="Novecta Solutions"
              className="h-6 xs:h-7 sm:h-8 md:h-10 lg:h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex gap-8 items-center">
            <Link to="/" className={linkClass('/')}>
              Home
            </Link>
            <Link to="/about" className={linkClass('/about')}>
              About Us
            </Link>
            <Link to="/innovation" className={linkClass('/innovation')}>
              Innovation
            </Link>
            <Link to="/contact" className={linkClass('/contact')}>
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={toggleMenu}
            className="md:hidden relative z-50"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6 text-[#003B5C]" />
            ) : (
              <Menu className="h-6 w-6 text-[#003B5C]" />
            )}
          </button>

          {/* Mobile Navigation */}
          <div className={`
            fixed left-0 right-0 top-[52px] h-[calc(100vh-52px)]
            bg-[#7ce7ca]/50 backdrop-blur-sm md:hidden
            flex flex-col items-center pt-6
            transition-transform duration-300 ease-in-out
            ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}
          `}>
            <div className="flex flex-col items-center gap-4 bg-[#7ce7ca]/95 w-full py-4">
              <Link 
                to="/" 
                className={`${linkClass('/')} text-xl`}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/about" 
                className={`${linkClass('/about')} text-xl`}
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>
              <Link 
                to="/innovation" 
                className={`${linkClass('/innovation')} text-xl`}
                onClick={() => setIsMenuOpen(false)}
              >
                Innovation
              </Link>
              <Link 
                to="/contact" 
                className={`${linkClass('/contact')} text-xl`}
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;